<section class="user-migration-page">
  <header class="user-migration-header">
    <div class="user-migration-title">
      <mat-icon>people</mat-icon>
      <div>
        <h1>Migracion de Usuarios</h1>
        <p>Gestiona la migracion de usuarios desde la base de datos de Biblioteca Documentos</p>
      </div>
    </div>
    <p class="user-migration-disclaimer">
      Se muestran unicamente usuarios <strong>habilitados</strong> y <strong>aprobados</strong> de la base de datos de Biblioteca Documentos.
    </p>
  </header>

  <div class="user-migration-section">
    <h2>Filtros</h2>
    <div class="filters-form">
      <div class="filter-row filter-row--search">
        <mat-form-field floatLabel="always">
          <mat-label>Buscar usuarios</mat-label>
          <input matInput [formControl]="searchControl" (keyup)="applyFilter($event)"
            placeholder="Email, nombre, apellido, documento...">
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>

        <app-autocomplete label="Accesos" placeholder="Buscar acceso..." [options]="getFilteredOptions('levels')"
          [selectedValue]="filterService.getCurrentState().selectedLibraryLevel"
          (selectionChanged)="onLibraryLevelChange($event)">
        </app-autocomplete>

      </div>

      <div class="filter-row filter-row--secondary">
        <app-autocomplete label="Area Apostol" placeholder="Buscar area..." [options]="getFilteredOptions('areas')"
          [selectedValue]="selectedArea" (selectionChanged)="onAreaFilterChange($event)">
        </app-autocomplete>

        <app-autocomplete label="Distrito" placeholder="Buscar distrito..." [options]="getFilteredOptions('distritos')"
          [selectedValue]="selectedDistrito" (selectionChanged)="onDistritoFilterChange($event)">
        </app-autocomplete>

        <app-autocomplete label="Comunidad/Iglesia" placeholder="Buscar comunidad..."
          [options]="getFilteredOptions('comunidades')" [selectedValue]="selectedComunidad"
          (selectionChanged)="onComunidadFilterChange($event)">
        </app-autocomplete>
      </div>
    </div>
  </div>

  <div class="user-migration-section">
    <app-table-surface
      tableId="user-migration"
      title="Usuarios legacy"
      titleIcon="cloud_upload"
      [columns]="columns"
      [data]="tableData"
      [isLoading]="isLoading"
      [errorMessage]="errorMessage"
      [paginationConfig]="paginationConfig"
      [showPageSizeSelector]="true"
      [pageSizeOptions]="[5, 10, 25, 50, 100]"
      [cellTemplate]="cellContent"
      (pageChange)="onPageChange($event)"
      (pageSizeChange)="onPageSizeChange($event)">
    </app-table-surface>

    <ng-template #cellContent let-column="column" let-row="row">
      <div *ngIf="column === 'userInfo'" class="table-cell-stack user-migration-user-cell">
        <div *ngIf="row?.legacyData" class="table-cell-stack">
          <div class="table-cell-line">
            <mat-icon>email</mat-icon>
            <strong>{{ row.legacyData.email }}</strong>
          </div>
          <div class="table-cell-line table-cell-line--muted">
            <mat-icon>person</mat-icon>
            <span>{{ row.legacyData.firstName }} {{ row.legacyData.lastName }}</span>
          </div>
          <div class="table-cell-line table-cell-line--small table-cell-line--muted">
            <mat-icon>badge</mat-icon>
            <span>Doc: {{ row.legacyData.documentNumber }}</span>
          </div>
        </div>
      </div>

      <div *ngIf="column === 'accesos'" class="table-cell-stack accesos-card">
        <div *ngIf="row?.legacyData">
          <div class="accesos-pills">
            <span class="table-cell-badge table-cell-badge--neutral pill-badge" *ngFor="let access of row.legacyData.libraryAccesses">
              {{ access.id }} - {{ access.name }}
            </span>
          </div>
        </div>
      </div>

      <div *ngIf="column === 'roles'" class="badge-column">
        <div *ngIf="row?.legacyData">
          <div class="badges">
            <div class="table-cell-badge table-cell-badge--warning" *ngIf="row.legacyData.isEditor">
              <mat-icon>edit</mat-icon>
              <span>Editor</span>
            </div>
            <div class="table-cell-badge table-cell-badge--success" *ngIf="row.legacyData.isValidator">
              <mat-icon>check_circle</mat-icon>
              <span>Validador</span>
            </div>
            <span *ngIf="!row.legacyData.isEditor && !row.legacyData.isValidator" class="table-cell-empty">-</span>
          </div>
        </div>
      </div>

      <div *ngIf="column === 'unidad'" class="table-cell-stack unidad-card">
        <div *ngIf="row?.legacyData">
          <div class="table-cell-line unit-main" *ngIf="row?.legacyData?.unitHierarchyInfo?.mainUnit">
            <strong>{{ row.legacyData.unitHierarchyInfo.mainUnit }}</strong>
          </div>
          <div class="table-cell-stack table-cell-stack--compact">
            <div class="table-cell-muted" *ngIf="row?.legacyData?.unitHierarchyInfo?.district">
              {{ row.legacyData.unitHierarchyInfo.district }}
            </div>
            <div class="table-cell-muted" *ngIf="row?.legacyData?.unitHierarchyInfo?.area">
              {{ row.legacyData.unitHierarchyInfo.area }}
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="column === 'status'" class="badge-column">
        <div class="badges">
          <div
            *ngIf="row.migrationStatus === MigrationStatus.Migrated && !migrationStateService.isMigrating(row.legacyData.email)"
            class="table-cell-badge table-cell-badge--success">
            <mat-icon>check_circle</mat-icon>
            <span>Migrado</span>
          </div>
          <div
            *ngIf="row.migrationStatus === MigrationStatus.Error && !migrationStateService.isMigrating(row.legacyData.email)"
            class="table-cell-badge table-cell-badge--danger"
            [matTooltip]="migrationStateService.getMigrationError(row.legacyData.email) || 'Error en la migracion'">
            <mat-icon>error_circle</mat-icon>
            <span>Error</span>
          </div>
          <div
            *ngIf="row.migrationStatus === MigrationStatus.MemberPending && !migrationStateService.isMigrating(row.legacyData.email)"
            class="table-cell-badge table-cell-badge--warning">
            <mat-icon>schedule</mat-icon>
            <span>Pendiente</span>
          </div>
          <div
            *ngIf="row.migrationStatus === MigrationStatus.UserPending && !migrationStateService.isMigrating(row.legacyData.email)"
            class="table-cell-badge table-cell-badge--warning">
            <mat-icon>warning</mat-icon>
            <span>Falta Usuario (local)</span>
          </div>
          <div
            *ngIf="row.migrationStatus === MigrationStatus.IdpUserMissing && !migrationStateService.isMigrating(row.legacyData.email)"
            class="table-cell-badge table-cell-badge--warning">
            <mat-icon>warning</mat-icon>
            <span>Falta Usuario (IdP)</span>
          </div>
        </div>
      </div>

      <div *ngIf="column === 'actions'" class="table-cell-actions">
        <button mat-raised-button color="primary" (click)="onOpenMigrationModal(row.legacyData)"
          *ngIf="row.migrationStatus !== MigrationStatus.UserPending"
          [disabled]="migrationStateService.isMigrating(row.legacyData.email) || row.migrationStatus === MigrationStatus.Migrated"
          [matTooltip]="row.migrationStatus === MigrationStatus.Migrated ? 'Usuario ya ha sido migrado' : 'Migrar usuario de Biblioteca'">
          <mat-icon>cloud_upload</mat-icon>
          Migrar
        </button>
        <button mat-raised-button color="primary" (click)="createUser(row.memberId)"
          *ngIf="row.migrationStatus === MigrationStatus.UserPending && !migrationStateService.isMigrating(row.legacyData.email)"
          [disabled]="migrationStateService.isMigrating(row.legacyData.email)" matTooltip="Crear usuario">
          <mat-icon>account_circle</mat-icon>
          Crear
        </button>
      </div>
    </ng-template>
  </div>
</section>
